import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <section className="min-h-[80vh] flex flex-col items-center justify-center text-center px-6 pt-24" data-testid="not-found">
            <p className="font-display italic text-8xl text-gold/30" aria-hidden="true">404</p>
            <h1 className="mt-4 text-3xl sm:text-4xl font-light tracking-tight text-ivory">
                Cette page a été <span className="font-display italic text-gold">repeinte.</span>
            </h1>
            <p className="mt-4 text-smoke max-w-md">
                Le lien n'existe pas ou la page a déménagé. Retournez à l'accueil
                ou demandez directement votre devis.
            </p>
            <div className="mt-8 flex gap-4">
                <Link to="/" className="rounded-full border border-ivory/40 text-ivory px-8 py-3.5 hover:border-gold hover:text-gold transition-colors" data-testid="notfound-home">
                    Accueil
                </Link>
                <Link to="/devis" className="rounded-full bg-gold text-ink font-bold px-8 py-3.5 hover:scale-[1.04] transition-transform" data-testid="notfound-devis">
                    Devis gratuit
                </Link>
            </div>
        </section>
    );
}
